<template>
  <div class="bg">
    <div class="wrap">
      <div class="head">
        购买指导：
        <span>选择产品</span>
        <span>扫码支付</span>支付成功、立即使用
      </div>
      <div class="main">
        <h2 class="main-tit">
          账号：
          <strong class="font-blue">{{userName}}</strong>
          <a class="btn-invoice fr" href="###" @click="openInvoice">开具发票</a>
        </h2>
        <div class="main-table">
          <div class="main-table-cont">
            <ul class="table-cont-column" v-if="!isSingle">
              <li class="th">产品</li>
              <li
                class="td"
                v-for="product in products"
                :key="product.id"
                :class="{selected: product.id==productId}"
                @click="selectProduct(product.id)"
              >{{product.name}}</li>
            </ul>
            <ul class="table-cont-column" v-else>
              <li class="th">产品</li>
              <li class="column-pdt" v-for="product in products" :key="product.id">
                <p class="column-pdt-tit">{{product.name}}</p>
                <a href="javascript:void(0);" class="fr" @click="buyMore">购买更多产品</a>
              </li>
            </ul>
            <ul class="table-cont-column">
              <li class="th">期限</li>
              <li class="duration-column">
                <div v-for="price in prices" :key="price.month">
                  <span
                    :class="{selected:price.month==monthCount }"
                    v-if="price.month == 12 || price.month == 24"
                    @click="selectMonth(price.month)"
                  >{{price.month | monthToYear}}年</span>
                </div>
              </li>
              <li class="column-totalPrice">
                <div
                  class="totalPrice-wrap"
                  v-for="price in prices"
                  :key="price.month"
                  v-show="price.month == monthCount"
                >
                  价格：
                  <span
                    class="totalPrice-org"
                    :class="{'totalPrice-org-line' : price.curPrice && price.oriPrice != price.curPrice}"
                  >{{price.oriPrice}}元/年</span>
                  <p
                    class="totalPrice-cur font-red"
                    v-if="price.curPrice && price.oriPrice != price.curPrice"
                  >{{price.curPrice}}元/年({{price.remark}})</p>
                </div>
              </li>
            </ul>
          </div>
          <a
            href="###"
            class="main-btn"
            :class="{'disabled': !protocolActive}"
            @click="orderConfirm"
          >立即购买</a>
        </div>
      </div>
      <div class="foot">
        <div class="foot-img fr">
          <img :src="wechatUrl"/>
          <p>
            扫一扫添加
            <br />企业微信在线咨询
          </p>
        </div>
        <div class="foot-select">
          <router-link :to="'/protocol'" target="_blank">使用软件许可协议</router-link>
          <!-- <a href="agreement.html" class="font-blue" target="_blank">使用软件许可协议</a> -->
          <span
            class="select-btn fr"
            :class="{selected: protocolActive}"
            @click="confirmProtocol"
          >我已仔细阅读相关协议，对其内容表示确认。</span>
        </div>
        <p class="foot-tips">
          如遇到支付问题，可随时拨打
          <strong class="font-blue">021-20219999</strong>，客服将第一时间帮你解决。
          <br />如需了解详情可点击进入大智慧官网
          <a href="javascript:void(0);" id="toWebsite">www.gw.com.cn</a>
        </p>
      </div>
      <!-- 电子发票组件 -->
      <invoice ref="invoice" />
    </div>
  </div>
</template>

<script>
import Invoice from "@/components/invoice/Invoice.vue";
export default {
  data() {
    return {
      wechatUrl: require("@/assets/images/common/wechat.png"),
      protocolActive: true,
      token: "",
      pid: null,
      source: null,
      isSingle: false,
      userName: null,
      productId: null,//默认产品或选中的产品
      monthCount: 12,//默认期限或选中的期限
      products: [],
      prices: []
    };
  },
  created() {
    document.title = "PC购买入口";
    var token = this.$route.query.token;
    var pid = this.$route.query.pid;
    var source = this.$route.query.s;
    if (token == null || token == "") {
      console.log("请求token为空");
      window.close();
    }
    this.token = token;
    if (pid) {
      this.pid = pid;
    }
    if (source) {
      this.source = source;
    }
    this.getData();
  },
  methods: {
    getData() {
      var params = {
        token: this.token
      };
      if (this.pid) {
        params.pid = this.pid;
      }
      this.$get("/client/product", params)
        .then(response => {
          if (response.code === 0) {
            this.$storage.saveUserName(response.data.userName);
            this.userName = response.data.userName;
            this.productId = response.data.productId;
            this.products = response.data.products;
            this.prices = response.data.prices;
            if (this.products.length == 1) {
              this.isSingle = true;
            } else {
              this.isSingle = false;
            }
          } else if (response.code === 101) {
            window.close();
          } else {
            alert(response.msg);
            window.close();
          }
        })
        .catch(err => {
          alert("网络异常，请稍后重试");
          window.close();
        });
    },
    selectProduct(productId) {
      this.productId = productId;
      this.monthCount = 12;
      this.$get("/product/price?id=" + productId)
        .then(response => {
          if (response.code === 0) {
            this.prices = response.data;
          } else if (!(response.code == 100 || response.code == 101)) {
            this.$alert(response.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    },
    selectMonth(monthCount) {
      this.monthCount = monthCount;
    },
    openInvoice() {
      this.$refs.invoice.openInvoice();
    },
    confirmProtocol() {
      this.protocolActive = !this.protocolActive;
    },
    orderConfirm() {
      if (!this.protocolActive) {
        this.$alert(
          "请仔细阅读“上海大智慧信息科技有限公司软件产品许可使用协议”，阅读结束后同意请选中“我同意协议”钩选框，然后继续购买。",
          "提示",
          {
            confirmButtonText: "确定"
          }
        );
        return false;
      }
      // 保存订单并跳转到支付页面
      var params = {
        productId: this.productId,
        monthCount: this.monthCount,
        invoiceTitleType: this.$refs.invoice.invoiceTitleType
      };
      if (this.source) {
        params.source = this.source;
      }
      this.$post("/order/save", params)
        .then(response => {
          if (response.code === 0) {
            this.$router.push("/client/order/" + response.data.id);
          } else if (response.code != 100) {
            this.$alert(response.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    },
    buyMore(){
      var params = {token: this.token}
      if (this.source) {
        params.s = this.source;
      }
      this.$router.push({path: '/client/product.html', query: params})
      location.reload();
    }
  },
  // watch: {
  //   $route (to, from) {
  //     this.$router.go(0);
  //   }
  // },
  components: {
    Invoice
  },
  mounted() {
    document.getElementsByTagName("body")[0].className="bodyWidth";
  },
  beforeDestroy(){
    document.body.removeAttribute("class","bodyWidth");
  }
};
</script>

<style lang="scss">
.bodyWidth{min-width: 300px;}
</style>
<style lang="scss" scoped>
.main{margin-top: 0;margin-bottom: 0;}
</style>



// WEBPACK FOOTER //
// src/pages/client/Product.vue